import React, { useState } from "react";
import { Pagination, Stack } from "@mui/material";

const items = [...Array(100).keys()]; // Liste d'éléments fictifs (0 à 99)

function PaginatedList({
    page, setPage,
    nbrItems, itemsPerPage,
                       }) {
    // const [page, setPage] = useState(1);
    // const itemsPerPage = 10; // Nombre d'éléments par page

    // Calculez les limites d'affichage pour chaque page
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    // const paginatedItems = items.slice(start, end);

    const handleChange = (event, value) => {
        setPage(value);
        console.log(`Page actuelle : ${value}`);
    };

    return (
        <Stack spacing={3}>
            <Pagination
                count={Math.ceil(nbrItems / itemsPerPage)} // Total de pages
                page={page} // Page actuelle
                onChange={handleChange}
                variant="outlined"
                shape="rounded"
                color="success"
            />
        </Stack>
    );
}

export default PaginatedList;